import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Secure Authentication",
        description: "Implement multi-factor authentication (MFA) and strong password policies to protect user accounts.",
        imgUrl: "./img/services/web-security/secure-authenciation.jpg",
    },
    {
        title: "Data Encryption",
        description: "Ensure sensitive data is encrypted during transmission and storage using SSL/TLS protocols.",
        imgUrl: "./img/services/web-security/data-encryption.jpg",
    },
    {
        title: "Regular Security Updates",
        description: "Keep software, plugins, and frameworks updated to address known vulnerabilities.",
        imgUrl: "./img/services/web-security/regular-security-updates.jpg",
    },
    {
        title: "Firewall Protection",
        description: "Use firewalls to block unauthorized access and filter traffic.",
        imgUrl: "./img/services/web-security/firewall-protection.png",
    },
    {
        title: "DDoS Mitigation",
        description: "Implement tools to detect and mitigate distributed denial-of-service attacks.",
        imgUrl: "./img/services/web-security/ddos-mitigation.png",
    },
    {
        title: "Secure APIs",
        description: "Protect APIs with rate limiting, authentication, and input validation to prevent misuse.",
        imgUrl: "./img/services/web-security/secure-apis.jpg",
    },
];


const WebSecurity = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Web Security", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Web Security" description="Protect your website, users, and data with robust web security strategies and best practices." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>Why Web Security Matters</h2>
                            <p>
                                In today’s digital age, web security is crucial to protect sensitive information, ensure website availability, and build user trust. Cyberattacks can compromise personal data, disrupt operations, and harm your reputation. A proactive approach to web security is essential for every business.
                            </p>
                            <img
                                src="./img/services/web-security.jpg"
                                alt="Web Security"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Best Practices for Web Security</h2>
                            <ul>
                                <li>Conduct regular security audits and vulnerability assessments.</li>
                                <li>Use strong, unique passwords and enable multi-factor authentication.</li>
                                <li>Regularly back up data and test restoration processes.</li>
                                <li>Educate employees on phishing attacks and safe browsing practices.</li>
                                <li>Implement proper access controls and limit permissions.</li>
                                <li>Monitor logs and detect unusual activity promptly.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Enhance Your Web Security Today</h2>
                            <p>
                                Partner with us to build a secure online presence. <br />
                                Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default WebSecurity;
